import { CSSProperties, FC } from 'react';
import classes from './ExportReportButton.module.scss';
import {DownloadState} from './PatientsControls';

type ExportReportButtonProps = {
  progress: number;
  state: DownloadState;
  onClick: () => void;
}

export const ExportReportButton: FC<ExportReportButtonProps> = ({state, progress, onClick}) => {
  const formattedProgress = progress.toFixed(2);

  const text =
    state === 'idle'
      ? 'Generate'
      : state === 'downloading'
        ? `${formattedProgress}%`
        : 'Download';

  return (
    <div
      className={classes.download}
      role="button"
      tabIndex={0}
      onClick={onClick}
      style={
        {
          '--progress': `${progress}%`,
        } as CSSProperties
      }
    >
      <div className={classes.download__fill} />

      <span className={classes.download__text}>
        {text}
      </span>
    </div>
  );
};